export default __webpack_public_path__ + "static/picture-d166bc62bbc2b0ba987a2b2399537716.jpg";